module.exports = __webpack_public_path__ + "static/media/qmo_logo.3bad94f2.png";